import { ActivityEntityName } from '../../../../entities';
import { getSchema, MergeField, MergeSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.Company
})
export class CompanyMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    taxId: string;

    @MergeField()
    email: string;

    @MergeField()
    phone: string;

    @MergeField()
    street: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    accountNumber: string;

    @MergeField()
    branchNumber: string;

    @MergeField()
    logo: string;

    @MergeField({
        displayName: "Logo Image small (only for html)"
    })
    logoImageSmall: string;

    @MergeField({
        displayName: "Logo Image Large (only for html)"
    })
    logoImageLarge: string;
}

export const CompanyMergeSchema = getSchema(CompanyMergeData);